var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorsomissionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.336 0.989116L4.9314 3.78906L8.53144 52.071L45.936 49.2711L42.336 0.989116Z",
    fill: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8492 0H9.3396V48.4175H46.8492V0Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7731 22.0308C23.0143 23.7931 20.4512 24.4814 18.049 23.8358C15.6468 23.1911 13.7707 21.3104 13.1264 18.9035C12.4829 16.4965 13.1699 13.9284 14.9278 12.1662C16.6866 10.404 19.2497 9.71562 21.6519 10.3612C24.0542 11.0059 25.9303 12.8866 26.5746 15.2935C27.2189 17.7014 26.5319 20.2695 24.7731 22.0308Z",
    fill: "#F6D864"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7731 22.0304C23.0143 23.7926 20.4512 24.481 18.049 23.8354C15.6468 23.1907 13.7707 21.31 13.1264 18.903C12.4829 16.4961 13.1699 13.928 14.9278 12.1658C16.3036 10.7873 18.1708 10.066 20.0691 10.1266L19.8505 17.0981L24.7731 22.0304Z",
    fill: "#0593A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7731 22.03C23.0143 23.7922 20.4512 24.4805 18.049 23.8349C15.6468 23.1902 13.7707 21.3096 13.1263 18.9026C13.0632 18.6658 13.0126 18.4271 12.9744 18.1885L19.8496 17.0977L24.7731 22.03Z",
    fill: "#E96B57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2151 10.2148H31.7053V17.352H34.2151V10.2148Z",
    fill: "#00A683"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2136 6.0957H34.7039V17.3504H37.2136V6.0957Z",
    fill: "#3E8DB8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2114 5.05273H37.7017V17.351H40.2114V5.05273Z",
    fill: "#E96B57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2097 7.94727H40.7V17.3515H43.2097V7.94727Z",
    fill: "#FFD01A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1022 35.5906L33.896 34.1943L37.3603 33.6797L40.3037 28.5078L41.5275 29.2068L38.2445 34.9753L34.1022 35.5906Z",
    fill: "#DF4937"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1764 44.4888L16.5623 44.1442L19.759 38.4229L23.7147 37.4354L25.7153 33.6091L30.078 33.1816L32.4722 34.764L33.9475 34.545L34.0506 35.2431L32.3096 35.5013L29.8985 33.9083L26.1632 34.2743L24.1929 38.0436L20.2238 39.0347L17.1764 44.4888Z",
    fill: "#DF4937"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.971 44.6111H16.574V29.6797H16.869V44.3164H37.971V44.6111Z",
    fill: "#575756"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1038 29.8177L16.7214 27.5078L17.34 29.8177H16.1038Z",
    fill: "#575756"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8848 45.0547L40.0853 44.4634L37.8848 43.873V45.0547Z",
    fill: "#575756"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6799 29.8189L41.8074 27.2891L41.4181 31.298L38.6799 29.8189Z",
    fill: "#DF4937"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2494 37.8693H26.348C26.1534 37.8693 25.9961 37.7117 25.9961 37.5167C25.9961 37.3217 26.1534 37.1641 26.348 37.1641H31.2494C31.444 37.1641 31.6013 37.3217 31.6013 37.5167C31.6013 37.7108 31.444 37.8693 31.2494 37.8693Z",
    fill: "#706F6F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3628 39.5021H26.348C26.1534 39.5021 25.9961 39.3445 25.9961 39.1495C25.9961 38.9545 26.1534 38.7969 26.348 38.7969H33.3628C33.5574 38.7969 33.7147 38.9545 33.7147 39.1495C33.7147 39.3436 33.5574 39.5021 33.3628 39.5021Z",
    fill: "#706F6F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5644 3.15642H13.361C13.1663 3.15642 13.009 2.99881 13.009 2.80379C13.009 2.60878 13.1663 2.45117 13.361 2.45117H33.5644C33.759 2.45117 33.9163 2.60878 33.9163 2.80379C33.9163 2.99881 33.759 3.15642 33.5644 3.15642Z",
    fill: "#706F6F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8558 5.40448H13.362C13.1673 5.40448 13.01 5.24685 13.01 5.05184C13.01 4.85683 13.1673 4.69922 13.362 4.69922H29.8558C30.0505 4.69922 30.2078 4.85683 30.2078 5.05184C30.2078 5.24685 30.0505 5.40448 29.8558 5.40448Z",
    fill: "#706F6F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7718 7.65252H13.362C13.1673 7.65252 13.01 7.49491 13.01 7.2999C13.01 7.10489 13.1673 6.94727 13.362 6.94727H27.7718C27.9664 6.94727 28.1237 7.10489 28.1237 7.2999C28.1237 7.49491 27.9664 7.65252 27.7718 7.65252Z",
    fill: "#706F6F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1365 41.1349H26.348C26.1534 41.1349 25.9961 40.9773 25.9961 40.7823C25.9961 40.5873 26.1534 40.4297 26.348 40.4297H36.1365C36.3311 40.4297 36.4884 40.5873 36.4884 40.7823C36.4884 40.9773 36.3311 41.1349 36.1365 41.1349Z",
    fill: "#706F6F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1365 42.7658H26.348C26.1534 42.7658 25.9961 42.6082 25.9961 42.4132C25.9961 42.2182 26.1534 42.0605 26.348 42.0605H36.1365C36.3311 42.0605 36.4884 42.2182 36.4884 42.4132C36.4884 42.6082 36.3311 42.7658 36.1365 42.7658Z",
    fill: "#706F6F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6712 25.5293H28.0632L22.1947 32.9773C22.1947 32.9773 21.6079 47.548 36.6712 56.3581V25.5293Z",
    fill: "#B2B2B2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6711 25.5293H45.2791L51.1484 32.9773C51.1484 32.9773 51.7353 47.548 36.672 56.3581L36.6711 25.5293Z",
    fill: "#9B9B9B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6712 27.7305H28.9887L24.4501 33.3824C24.4501 33.3824 23.4613 45.4084 36.6712 53.9286V27.7305Z",
    fill: "#E24434"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6712 27.7305H44.3529L48.8915 33.3824C48.8915 33.3824 49.8803 45.4084 36.6704 53.9286L36.6712 27.7305Z",
    fill: "#D32920"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7317 34.0668C32.7317 34.0668 31.3632 33.6715 30.5257 32.7146C29.8846 31.9825 29.4325 30.4861 29.4317 30.4902C29.43 30.4861 28.978 31.9833 28.3369 32.7146C27.4994 33.6707 26.1309 34.0668 26.1309 34.0668C26.1309 34.0668 27.4657 34.5436 28.2218 35.3804C28.9804 36.2187 29.435 37.5174 29.4366 37.5199C29.4366 37.5199 29.8829 36.2187 30.6407 35.3804C31.3961 34.5436 32.7317 34.0668 32.7317 34.0668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorsomissionicon);
export default __webpack_public_path__ + "static/media/errors & omission icon.1a823e45acfcbe3dc1fb6937a1e7bf33.svg";
export { ForwardRef as ReactComponent };